import { changeHeaderStyleOnOpenModal } from "./searchAndOverlayModals";

$(function() {
    const $closeModal = $('.close-modal');
    const $loadMoreBtn = $('#fl-search-loadmore');
    const flSearchModalSelector = '#footballLanguageSearchModal';
    let offset = 0;

    $('.fl-block__search-icon').on('click', () => {
        $('input.fl-block__input').trigger('change');
    });

    $('input.fl-block__input').on("change", function(event) {
        event.preventDefault();
        openSearchModal();
        getSearchResults($(this).val());
    });

    $('input.search-modal__input').on('change', function() {
        $('.search-modal__football-language-items').html('');
        $('.search-modal__result span').html(0);
        getSearchResults($(this).val());
    });

    $loadMoreBtn.on('click', () => {
        const val = $('input.football-language-search__input').val();
        offset += 12;
        getSearchResults(val, offset);
    });

    $closeModal.on('click', () => $(flSearchModalSelector).modal('hide'));

    $('.search-modal__close-icon').on('click', clearSearchModal);

    function getSearchResults(filter, offset = 0) {
        const $searchContainer = $('#footballLanguageSearchModal');
        $('input.football-language-search__input', $searchContainer).val(filter).focus();
        const lang = currentEnvironment.language;
        const limit = 12; // 12 items is standard amount, offset 0 by default
        const url = `/${lang}/football-language/search?filter=${filter}&limit=${limit}&offset=${offset}`;

        $.getJSON(url, ({ data, count }) => showSearchResult(data, offset, count))
    }

    $(document).on('click','a.football-language-search__card', function() {
        window.location.href = $(this).attr('href');
        window.location.reload();
    });

    function showSearchResult(data, offset, count) {
        $.each(data, function(_, item) {
            $('.search-modal__football-language-items').append(
                `<a class="regular-card search-modal__card football-language-search__card" href="${item.url}">
                    <div class="regular-card__content football-language-search__content">
                        <div class="regular-card__title football-language-search__title">
                            ${item.headline}
                        </div>
                        <span class="football-language-search__breadcrumb">
                            ${item.breadcrumb}
                        </span>
                    </div>
                </a>`
            )
        });

        $('.football-language-result span').html(count || 0);

        const limit = 12;

        if (offset + limit < count) {
            // Show "load more" buttom
            $loadMoreBtn.show()
        } else {
            $loadMoreBtn.hide()
        }
    }

    function openSearchModal() {
        $('#overlayModal').modal('hide');
        $('#searchModal').modal('hide');
        $closeModal.attr({'data-bs-target': flSearchModalSelector});
        $('#footballLanguageSearchModal').modal('show');
        $('body').css({overflow: 'hidden'});
        changeHeaderStyleOnOpenModal();
    }

    function clearSearchModal() {
        $('.search-modal__football-language-items').html('');
        $('.search-modal__input').val('');
        $('.search-modal__result span').html(0);
        $('.search-modal__btn').css({display: 'none'});
        $('.fl-block__input').val('');
    }
});



